import * as React from "react";
import PropTypes from "prop-types";
import { Route, Router } from "react-router-dom";

// This is used to render a portion of a MemoryRouter, for the sake of showing
// old state in transitions. If you call any methods on its history, it actually
// calls the method on outer history (provided to this component via a Router).
export default class SubMemoryRouter extends React.Component {
  static propTypes = {
    entries: PropTypes.arrayOf(PropTypes.object).isRequired,
    index: PropTypes.number.isRequired,
    children: PropTypes.node,
  };

  // Keep history cached here because Router doesn't like it if we give it a new
  // history object every render.
  _history = {};

  render() {
    return (
      <Route
        render={({ history: outerHistory }) => {
          const { index, entries } = this.props;

          Object.assign(this._history, outerHistory, {
            index,
            entries,
            length: entries.length,
            location: entries[index],
          });

          return <Router history={this._history}>{this.props.children}</Router>;
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Routing/SubMemoryRouter.jsx